import { useAuth } from '../../../context/AuthContext'
import ListModule from '../../module/ListModule'
import { useOutletContext } from 'react-router-dom'
import { supplierColumns } from './SupplierFields'
import { useMemo } from 'react'

const ListSupplier = () => {
  const { user } = useAuth()
  const userRight = useOutletContext()
  const companyId = user?.company_id

  const objectFilter = useMemo(() => ({ company_id: companyId }), [companyId])

  const options = useMemo(() => {
    if (!companyId) return null

    return {
      objectType: 'suppliers',
      accessRight: userRight,
      objectFilter: () => objectFilter,
      actions: {
        add: true,
        edit: true,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer le fournisseur',
          field: 'supplier_name'
        }
      },
      isExpand: false,
      isFilter: true,
      columns: supplierColumns
    }
  }, [companyId, userRight, objectFilter])

  const toolbar = useMemo(
    () => ({
      objectType: 'suppliers',
      title: 'Fournisseurs',
      accessRight: userRight,
      actions: {
        add: true
      },
      columns: options.columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, options]
  )

  return <ListModule options={options} toolbar={toolbar} />
}

export default ListSupplier
